import Vue from "vue";
import App from "./App.vue";
import VeeValidate, { Validator } from "vee-validate";
import router from "./routes";
import store from "./store";

//datepicker
import { Datetime } from "vue-datetime";
// You need a specific loader for CSS files
import "vue-datetime/dist/vue-datetime.css";

import interceptorsSetup from "./helpers/interceptors";

const dictionary = {
  en: {
    messages: {
      confirmed: function() {
        return "Password and repeat password donot match";
      },
      email: function() {
        return "Please provide valid email address";
      },
    },
  },
};
Validator.localize(dictionary);
//set validator
Vue.use(VeeValidate, {
  fieldsBagName: "veeFields",
});

Vue.config.productionTip = false;

// and running it somewhere here
interceptorsSetup();

Vue.component("datetime", Datetime);

//load moment
Vue.use(require("vue-moment"));

new Vue({
  render: (h) => h(App),
  router,
  store,
}).$mount("#app");
